<template>
  <div>
    <b-card class="bg-t-dark">
        <b-row>
            <b-col md="2">
                <b-row>
                    <b-col class="text-center">
                        <EnlightMockupImg/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-center mt-2">
                        <h5>
                            ENLIGHT 2100
                        </h5>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="8">
                <b-row>
                    <b-col md="6">
                        <b-row class="mt-1 mt-om">
                            <b-col class="">
                                <b-row>
                                    <b-col>
                                        <h6>
                                            {{$t("Serial number")}}: E21001125 
                                        </h6>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mt-om">
                            <b-col class="">
                                <b-row>
                                    <b-col>
                                        {{$t("Last maintenance")}}: DD/MM/YYYY 
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mt-om">
                            <b-col class="">
                                <b-row>
                                    <b-col>
                                        {{$t("Mode")}}: Normal - Anvisa
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row class="mt-1 mt-om">
                            <b-col md="5" class="text-end-od">
                                {{$t("Modules")}}:
                            </b-col>
                            <b-col md="7">
                                <b-row>
                                    <b-col>
                                        Assincronia
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        Titulação de PEEP
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        TVz + EELZ
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        Sensorless
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="2" class="mt-om text-end" align="end">
                <b-row class="order-card-buttons  mt-om">
                    <b-col>
                        <b-btn id="equipment-detail" class="m-2" variant="t-blue" @click="$router.push('equipment')">
                            {{$t("Details")}}
                        </b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<script>
import EnlightMockupImg from '@/assets/img/EnlightMockupImg'

export default {
    components:{
        EnlightMockupImg
    },

}
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
    .btn{
        margin-bottom: 5px;
    }
}
@media only screen and (min-width: 600px) {
    .order-card-buttons{  
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
}
</style>